import ko from 'knockout';

export class Hospital {
    constructor(mgr) {
        this.mgr = mgr;
        this.id = ko.observable();
        this.name = ko.observable();
        this.address = ko.observable();

        this.fullName = ko.pureComputed(() => {
            if (this.address()) {
                return `
                <p class="margin-0 text-small">${this.name()}</p>
                <p class="text-muted margin-0 text-smaller truncate">
                    ${this.address()}
                </p>`;
            } else {
                return `<p class="margin-0 text-small">${this.name()}</p>`;
            }
        });
    }

    load(data) {
        this.id(data.id);
        this.name(data.name);
        if (data.locality) {
            this.address(
                `${data.locality.name}${
                    data.locality.state?.name
                        ? ', ' + data.locality.state.name
                        : ''
                }`,
            );
        }
    }
}
